"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = isVisible;

/**
 * @file 元素是否可见
 * @author zhangyanting
 */
function isVisible(dom) {
  var computedStyle = window.getComputedStyle(dom);
  var displayValue = computedStyle.getPropertyValue('display');
  return displayValue !== 'none';
}